import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { AUTH_API, CRM_API, errMsg } from "./api";

const CrmAuthCtx = createContext(null);

export function CrmAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await CRM_API.get("/me");
      setUser(data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = useCallback(async (email, password) => {
    setError(null);
    try {
      await AUTH_API.post("/auth/login", { email, password });
      await refresh();
      return true;
    } catch (e) {
      setError(errMsg(e));
      return false;
    }
  }, [refresh]);

  const logout = useCallback(async () => {
    try { await AUTH_API.post("/auth/logout"); } catch (_e) { /* ignore */ }
    setUser(null);
    window.location.href = "/crm/login";
  }, []);

  return (
    <CrmAuthCtx.Provider value={{ user, loading, error, login, logout, refresh }}>
      {children}
    </CrmAuthCtx.Provider>
  );
}

export const useCrmAuth = () => useContext(CrmAuthCtx);
